import { memo as Memo, useMemo } from 'react'

//* Components
import Image from 'components/common/Image'
import Text from 'components/common/Text'
import Button from 'components/common/Button'
import BackButton from '../BackButton'

//* Styles
import InfoNavbarStyle from './style'

const InfoNavbar = Memo(({ selectedInfo, selectedCategory, clearInfo }) => {
	const selectedColor = useMemo(() => (selectedCategory ? selectedCategory.color : selectedInfo?.cat?.color), [selectedInfo, selectedCategory])

	return (
		<InfoNavbarStyle className={`${selectedInfo ? 'active' : ''}`}>
			{selectedInfo && (
				<>
					<BackButton onClick={clearInfo} />
					<div className='in-info-container'>
						<Image objectFit='cover' src={selectedInfo.image.url} alt={selectedInfo.image.alt} />

						<Text text={selectedInfo.name} className='in-title font-ping-medium h5' />
						<Text text={selectedInfo.region_name} className='in-region font-helvetica p pS secondaryColor2' />
						<Text text={selectedInfo.description} className='in-desc font-helvetica p pXS' />

						{selectedInfo.link && (
							<Button
								className={`in-btn Color${selectedColor}`}
								url={selectedInfo.link}
								customLinkProps={{ options: { target: '_blank' } }}
								type='icon-aside'
								text={'detailsPage'}
								color={'ColorWhite'}
								background={`Color${selectedColor}`}
								hoverColor={`Color${selectedColor}`}
								hoverBackground={'ColorApricot'}
							/>
						)}
					</div>
				</>
			)}
		</InfoNavbarStyle>
	)
})

export default InfoNavbar
